import { DialogContent, DialogTitle } from "@mui/material";
import styles from "./promptsList.module.css";
import { ArrowLeft, Delete, Edit, Plus, Trash2, X } from "react-feather";
import { useState } from "react";
import PromptSearch from "./PromptSearch";

const PromptListing = (props) => {
  return (<>
    <DialogTitle id="alert-dialog-title" className={`${styles.CustomTitle}`}>
      <button className={`${styles.BackAddBU}`} onClick={(e) => props?.handleCloseModal(false)}>
        <ArrowLeft />
      </button>
      Prompts
      <button onClick={(e) => props?.handleCloseModal(false)} className={`${styles.ModalCloseBU}`}>
        <X />
      </button>
    </DialogTitle>
    <DialogContent className={`${styles.RequestBodyPop}`}>
      <div className={`${styles.PromptListMainSec}`}>
        <div className={`${styles.PromptListSearchSec}`}>
          <PromptSearch {...props} />
          <button className={`${styles.AddPromptBU}`} onClick={() => props?.setIsShowAddEditForm(true)}>
            <Plus /> prompt
          </button>
        </div>
        {props?.promptList?.length > 0 && props?.promptList.map((prompt) => {
          return (<div key={prompt?.id} className={`${styles.PromptListSec}`}>
            <div className={`${styles.PromptList}`}>
              <div>
                <p className={`${styles.Title}`}>{prompt?.title}</p>
                <p className={`${styles.Des}`}>{prompt?.description}</p>
              </div>
              <button onClick={(e) => props.setDetails(prompt)} className={`${styles.PromptListEditBU}`}>
                <Edit />
              </button>
              <button onClick={(e) => { props.setOpenPromptDeleteModal(true); props.setPromptId(prompt.id); }} className={`${styles.PromptListEditBU}`}>
                <Trash2 />
              </button>
            </div>
          </div>);
        })}

        {!props?.promptList?.length > 0 && (<div className={`${styles.NoDataMain}`}>
          <div className={`${styles.NoDataIMG}`}>
            <img src="/static/img/no-prospect.png" alt="No Data" />
          </div>
          <p className={`${styles.NoDataText}`}>Let's get started!</p>
          <p className={`${styles.NoDataTextSub}`}>Your prompt list is empty.</p>
        </div>)}
      </div>
    </DialogContent>
  </>);
};

export default PromptListing;